export function initHubspotChatDelay() {
    const hsHideStyle = document.createElement('style');
    hsHideStyle.textContent = '#hubspot-messages-iframe-container { opacity: 0 !important; pointer-events: none !important; transition: opacity 0.3s; }';
    document.head.appendChild(hsHideStyle);
    window.addEventListener('scroll', function showHubspot() {
        if (window.scrollY >= window.innerHeight) {
            hsHideStyle.remove();
            window.removeEventListener('scroll', showHubspot);
        }
    }, { passive: true });
}